/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import React from "react";
import { useEventsFilter } from "./hooks";
import GeneralFilter from "../../Shared/Filter/GeneralFilter";
import { resetEventFilters } from "../../../store/filters/events/EventFilterReducer";

interface EventsFilterProps {
  searchScope?: string;
}

export const EventsFilter: React.FC<EventsFilterProps> = ({ searchScope = "events" }) => {
  const { dispatch, eventFilters, formControlSx, searchTooltip } = useEventsFilter();


  return (
    <>
      <GeneralFilter dispatch={dispatch} filters={eventFilters} formControlSx={formControlSx} resetFilters={resetEventFilters} searchTooltip={searchTooltip} searchScope={searchScope} />
    </>
  );
};

export default EventsFilter;
